var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipArt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4565"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__g",
    x1: 193.483,
    x2: 261.389,
    y1: -42.221,
    y2: 281.931,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__h",
    x1: 48.968,
    x2: 82.071,
    y1: 64.844,
    y2: 155.326,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__i",
    x1: 64,
    x2: 64,
    y1: 126.284,
    y2: 142.467,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__j",
    x1: 103.479,
    x2: 126.123,
    y1: 105.931,
    y2: 105.931,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__k",
    x1: 176.968,
    x2: 210.071,
    y1: 64.844,
    y2: 155.326,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__l",
    x1: 192,
    x2: 192,
    y1: 126.284,
    y2: 142.467,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__m",
    x1: 231.479,
    x2: 254.123,
    y1: 105.931,
    y2: 105.931,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__n",
    x1: 304.968,
    x2: 338.071,
    y1: 64.844,
    y2: 155.326,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__o",
    x1: 320,
    x2: 320,
    y1: 126.284,
    y2: 142.467,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__p",
    x1: 359.479,
    x2: 382.123,
    y1: 105.931,
    y2: 105.931,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__q",
    x1: 432.968,
    x2: 466.071,
    y1: 64.844,
    y2: 155.326,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__r",
    x1: 448,
    x2: 448,
    y1: 126.284,
    y2: 142.467,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__s",
    x1: 487.479,
    x2: 510.123,
    y1: 105.931,
    y2: 105.931,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__t",
    x1: 112.968,
    x2: 146.071,
    y1: 139.878,
    y2: 230.361,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__u",
    x1: 128,
    x2: 128,
    y1: 201.318,
    y2: 217.502,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__v",
    x1: 167.479,
    x2: 190.123,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__w",
    x1: 240.968,
    x2: 274.071,
    y1: 139.878,
    y2: 230.361,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__x",
    x1: 256,
    x2: 256,
    y1: 201.318,
    y2: 217.502,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__y",
    x1: 295.479,
    x2: 318.123,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__z",
    x1: 368.968,
    x2: 402.071,
    y1: 139.878,
    y2: 230.361,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__A",
    x1: 384,
    x2: 384,
    y1: 201.318,
    y2: 217.502,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__B",
    x1: 423.479,
    x2: 446.123,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__C",
    x1: 468.023,
    x2: 494.399,
    y1: 148.227,
    y2: 220.323,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__D",
    x1: 480,
    x2: 480,
    y1: 201.318,
    y2: 217.502,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__E",
    x1: 493.792,
    x2: 515.736,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__F",
    x1: 20.023,
    x2: 46.399,
    y1: 148.227,
    y2: 220.323,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__G",
    x1: 32,
    x2: 32,
    y1: 201.318,
    y2: 217.502,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__H",
    x1: 45.792,
    x2: 67.736,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__I",
    x1: 48.968,
    x2: 82.071,
    y1: 214.913,
    y2: 305.395,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__J",
    x1: 64,
    x2: 64,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__K",
    x1: 103.479,
    x2: 126.123,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__L",
    x1: 176.968,
    x2: 210.071,
    y1: 214.913,
    y2: 305.395,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__M",
    x1: 192,
    x2: 192,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__N",
    x1: 231.479,
    x2: 254.123,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__O",
    x1: 304.968,
    x2: 338.071,
    y1: 214.913,
    y2: 305.395,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__P",
    x1: 320,
    x2: 320,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__Q",
    x1: 359.479,
    x2: 382.123,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__R",
    x1: 432.968,
    x2: 466.071,
    y1: 214.913,
    y2: 305.395,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__S",
    x1: 448,
    x2: 448,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__T",
    x1: 487.479,
    x2: 510.123,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__U",
    x1: 48.968,
    x2: 82.071,
    y1: 364.982,
    y2: 455.464,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__V",
    x1: 64,
    x2: 64,
    y1: 426.422,
    y2: 442.605,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__W",
    x1: 103.479,
    x2: 126.123,
    y1: 406.069,
    y2: 406.069,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__X",
    x1: 176.968,
    x2: 210.071,
    y1: 364.982,
    y2: 455.464,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__Y",
    x1: 192,
    x2: 192,
    y1: 426.422,
    y2: 442.605,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__Z",
    x1: 231.479,
    x2: 254.123,
    y1: 406.069,
    y2: 406.069,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aa",
    x1: 304.968,
    x2: 338.071,
    y1: 364.982,
    y2: 455.464,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ab",
    x1: 320,
    x2: 320,
    y1: 426.422,
    y2: 442.605,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ac",
    x1: 359.479,
    x2: 382.123,
    y1: 406.069,
    y2: 406.069,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ad",
    x1: 432.968,
    x2: 466.071,
    y1: 364.982,
    y2: 455.464,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ae",
    x1: 448,
    x2: 448,
    y1: 426.422,
    y2: 442.605,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__af",
    x1: 487.479,
    x2: 510.123,
    y1: 406.069,
    y2: 406.069,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ag",
    x1: 112.968,
    x2: 146.071,
    y1: 289.947,
    y2: 380.43,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ah",
    x1: 128,
    x2: 128,
    y1: 351.387,
    y2: 367.571,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ai",
    x1: 167.479,
    x2: 190.123,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aj",
    x1: 240.968,
    x2: 274.071,
    y1: 289.947,
    y2: 380.43,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ak",
    x1: 256,
    x2: 256,
    y1: 351.387,
    y2: 367.571,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__al",
    x1: 295.479,
    x2: 318.123,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__am",
    x1: 368.968,
    x2: 402.071,
    y1: 289.947,
    y2: 380.43,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__an",
    x1: 384,
    x2: 384,
    y1: 351.387,
    y2: 367.571,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ao",
    x1: 423.479,
    x2: 446.123,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ap",
    x1: 468.023,
    x2: 494.399,
    y1: 298.296,
    y2: 370.392,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aq",
    x1: 480,
    x2: 480,
    y1: 351.387,
    y2: 367.571,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ar",
    x1: 493.792,
    x2: 515.736,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__as",
    x1: 20.023,
    x2: 46.399,
    y1: 298.296,
    y2: 370.392,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__a"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__at",
    x1: 32,
    x2: 32,
    y1: 351.387,
    y2: 367.571,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__au",
    x1: 45.792,
    x2: 67.736,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__b"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__av",
    x1: 167.431,
    x2: 364.184,
    y1: 181.398,
    y2: 369.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efe2dd"
  }))), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9797",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3562,
    stopColor: "#9b9494",
    stopOpacity: 0.356
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    stopColor: "#928b8b",
    stopOpacity: 0.629
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#827a7a",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#766e6e"
  }))), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aw",
    x1: 237.436,
    x2: 257.402,
    y1: 380.782,
    y2: 380.782,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ax",
    x1: 363.989,
    x2: 382.524,
    y1: 275.169,
    y2: 291.565,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ay",
    x1: 403.197,
    x2: 403.197,
    y1: 261.02,
    y2: 298.089,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__az",
    x1: 256,
    x2: 256,
    y1: 352.98,
    y2: 372.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aA",
    x1: 369.728,
    x2: 369.728,
    y1: 334.802,
    y2: 373.312,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aB",
    x1: 146.185,
    x2: 146.185,
    y1: 340.505,
    y2: 372.958,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aC",
    x1: 108.778,
    x2: 108.778,
    y1: 273.495,
    y2: 297.591,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aD",
    x1: 110.782,
    x2: 132.942,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aE",
    x1: 142.869,
    x2: 142.869,
    y1: 201.139,
    y2: 220.794,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aF",
    x1: 172.802,
    x2: 194.763,
    y1: 181.131,
    y2: 181.131,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aG",
    x1: 371.216,
    x2: 371.216,
    y1: 199,
    y2: 222.525,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac600"
  }))), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aH",
    x1: 191.558,
    x2: 336.984,
    y1: 194.25,
    y2: 326.844,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__d"
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aI",
    x1: 256,
    x2: 256,
    y1: 199,
    y2: 221.467,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aJ",
    x1: 298.624,
    x2: 320.717,
    y1: 180.966,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aK",
    x1: 319.977,
    x2: 319.977,
    y1: 130.446,
    y2: 145.209,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aL",
    x1: 362.426,
    x2: 382.31,
    y1: 126.783,
    y2: 126.783,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aM",
    x1: 239.628,
    x2: 253.648,
    y1: 125.169,
    y2: 144.179,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__c"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aN",
    x1: 166.743,
    x2: 193.359,
    y1: 193.324,
    y2: 193.324,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aO",
    x1: 156.073,
    x2: 156.073,
    y1: 199.356,
    y2: 220.386,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aP",
    x1: 358.72,
    x2: 358.72,
    y1: 197.574,
    y2: 221.123,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aQ",
    x1: 192,
    x2: 192,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aR",
    x1: 234.584,
    x2: 258.822,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aS",
    x1: 320,
    x2: 320,
    y1: 276.353,
    y2: 292.536,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aT",
    x1: 352.921,
    x2: 384.762,
    y1: 256,
    y2: 256,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aU",
    x1: 256,
    x2: 256,
    y1: 345.02,
    y2: 371.266,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aV",
    x1: 297.317,
    x2: 319.199,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aW",
    x1: 170.426,
    x2: 194.307,
    y1: 331.035,
    y2: 331.035,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aX",
    x1: 160.571,
    x2: 160.571,
    y1: 348.822,
    y2: 371.158,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aY",
    x1: 414.046,
    x2: 476.778,
    y1: 167.361,
    y2: 179.718,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__d"
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__aZ",
    x1: 448.001,
    x2: 448.001,
    y1: 123.079,
    y2: 147.073,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__ba",
    x1: 428.01,
    x2: 448.534,
    y1: 155.082,
    y2: 155.082,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__bb",
    x1: 463.836,
    x2: 463.836,
    y1: 193.416,
    y2: 216.722,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__e"
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#433f43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__bc",
    x1: 119.107,
    x2: 297.681,
    y1: 79.517,
    y2: 403.517,
    gradientTransform: "rotate(-14.98 264.3 279.746)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__f"
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__bd",
    x1: 199.991,
    x2: 378.565,
    y1: 34.937,
    y2: 358.937,
    gradientTransform: "rotate(-14.98 264.3 279.746)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__f"
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clip-art_svg__be",
    x1: 138.076,
    x2: 316.651,
    y1: 69.062,
    y2: 393.062,
    gradientTransform: "rotate(-14.98 264.3 279.746)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#clip-art_svg__f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__g)",
    d: "M11.034 79.448h489.931v353.521H11.034z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__h)",
    d: "M116.966 143.448H11.034C4.94 143.448 0 138.508 0 132.414V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__i)",
    d: "M116.966 143.448H11.034C4.94 143.448 0 138.508 0 132.414V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__j)",
    d: "M116.966 68.414H51.494v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034V79.448c.001-6.094-4.939-11.034-11.033-11.034z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__k)",
    d: "M244.966 143.448H139.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__l)",
    d: "M244.966 143.448H139.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__m)",
    d: "M244.966 68.414h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034V79.448c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__n)",
    d: "M372.966 143.448H267.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__o)",
    d: "M372.966 143.448H267.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__p)",
    d: "M372.966 68.414h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034V79.448c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__q)",
    d: "M500.966 143.448H395.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__r)",
    d: "M500.966 143.448H395.034c-6.094 0-11.034-4.94-11.034-11.034V79.448c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__s)",
    d: "M500.966 68.414h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034V79.448c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__t)",
    d: "M180.966 218.483H75.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__u)",
    d: "M180.966 218.483H75.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__v)",
    d: "M180.966 143.448h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__w)",
    d: "M308.966 218.483H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__x)",
    d: "M308.966 218.483H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__y)",
    d: "M308.966 143.448h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__z)",
    d: "M436.966 218.483H331.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__A)",
    d: "M436.966 218.483H331.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__B)",
    d: "M436.966 143.448h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__C)",
    d: "M500.966 218.483h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__D)",
    d: "M500.966 218.483h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__E)",
    d: "M500.966 218.483h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__F)",
    d: "M52.966 218.483H11.034C4.94 218.483 0 213.542 0 207.448v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__G)",
    d: "M52.966 218.483H11.034C4.94 218.483 0 213.542 0 207.448v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__H)",
    d: "M52.966 218.483H11.034C4.94 218.483 0 213.542 0 207.448v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__I)",
    d: "M116.966 293.517H11.034C4.94 293.517 0 288.577 0 282.483v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__J)",
    d: "M116.966 293.517H11.034C4.94 293.517 0 288.577 0 282.483v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__K)",
    d: "M116.966 218.483H51.494v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c.001-6.095-4.939-11.035-11.033-11.035z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__L)",
    d: "M244.966 293.517H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__M)",
    d: "M244.966 293.517H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__N)",
    d: "M244.966 218.483h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.095-4.94-11.035-11.034-11.035z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__O)",
    d: "M372.966 293.517H267.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__P)",
    d: "M372.966 293.517H267.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__Q)",
    d: "M372.966 218.483h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.095-4.94-11.035-11.034-11.035z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__R)",
    d: "M500.966 293.517H395.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__S)",
    d: "M500.966 293.517H395.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__T)",
    d: "M500.966 218.483h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.095-4.94-11.035-11.034-11.035z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__U)",
    d: "M116.966 443.586H11.034C4.94 443.586 0 438.646 0 432.552v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__V)",
    d: "M116.966 443.586H11.034C4.94 443.586 0 438.646 0 432.552v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__W)",
    d: "M116.966 368.552H51.494v75.034h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c.001-6.094-4.939-11.034-11.033-11.034z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__X)",
    d: "M244.966 443.586H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__Y)",
    d: "M244.966 443.586H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__Z)",
    d: "M244.966 368.552h-65.471v75.034h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aa)",
    d: "M372.966 443.586H267.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ab)",
    d: "M372.966 443.586H267.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ac)",
    d: "M372.966 368.552h-65.471v75.034h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ad)",
    d: "M500.966 443.586H395.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ae)",
    d: "M500.966 443.586H395.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__af)",
    d: "M500.966 368.552h-65.471v75.034h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ag)",
    d: "M180.966 368.552H75.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ah)",
    d: "M180.966 368.552H75.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ai)",
    d: "M180.966 293.517h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aj)",
    d: "M308.966 368.552H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ak)",
    d: "M308.966 368.552H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__al)",
    d: "M308.966 293.517h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__am)",
    d: "M436.966 368.552H331.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__an)",
    d: "M436.966 368.552H331.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ao)",
    d: "M436.966 293.517h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.094-4.94-11.035-11.034-11.035z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ap)",
    d: "M500.966 368.552h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aq)",
    d: "M500.966 368.552h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ar)",
    d: "M500.966 368.552h-41.931c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c0 6.093-4.94 11.034-11.034 11.034z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__as)",
    d: "M52.966 368.552H11.034C4.94 368.552 0 363.611 0 357.517v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__at)",
    d: "M52.966 368.552H11.034C4.94 368.552 0 363.611 0 357.517v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__au)",
    d: "M52.966 368.552H11.034C4.94 368.552 0 363.611 0 357.517v-52.966c0-6.094 4.94-11.034 11.034-11.034h41.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.094-4.939 11.035-11.033 11.035z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__av)",
    d: "M422.101 206.128c-2.338-31.324-18.539-59.585-44.446-77.536-23.999-16.628-53.137-22.292-82.044-15.95-1.66.364-3.341.773-4.997 1.217-22.46 6.018-42.042 18.712-56.22 36.241-21.047-8.091-44.35-9.293-66.808-3.276-1.654.443-3.315.929-4.931 1.443-28.209 8.962-50.611 28.436-63.081 54.835-13.46 28.5-13.36 61.075.274 89.372 2.183 4.53 4.651 8.94 7.394 13.231.602.941.932 2.031.932 3.148v68.827a6.388 6.388 0 1012.776 0v-39.852c0-5.074 6.046-7.744 9.766-4.293 16.122 14.954 36.642 27.912 61.428 38.746 32.797 14.336 65.243 21.435 81.664 24.391 8.674 1.561 17.787 1.172 26.355-1.124 8.567-2.296 16.654-6.516 23.385-12.205 6.412-5.419 15.814-13.776 26.279-24.414 4.364-4.436 11.913-1.35 11.913 4.872v27.422a6.388 6.388 0 1012.776 0v-57.801c0-1.413.463-2.782 1.324-3.902l.12-.156c3.731-4.864 11.508-2.228 11.508 3.902v12.662c0 8.833 7.161 15.994 15.994 15.994s15.994-7.161 15.994-15.994V243.446c2.665-12.641 3.558-25.094 2.645-37.318z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aw)",
    d: "M244.966 368.552h-60.994a287.52 287.52 0 008.172 3.73c23.351 10.207 46.518 16.743 63.856 20.729v-13.425c0-6.094-4.94-11.034-11.034-11.034z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ax)",
    d: "M372.966 218.483h-65.471v75.035h65.471c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-6.095-4.94-11.035-11.034-11.035z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ay)",
    d: "M395.034 218.483c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h24.421v-50.072c1.773-8.409 2.744-16.732 2.938-24.963h-27.359z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__az)",
    d: "M308.966 368.552H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aA)",
    d: "M331.034 293.517c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h8.997a403.326 403.326 0 009.796-9.621c4.364-4.436 11.913-1.35 11.913 4.872v4.748h12.776v-35.128a6.4 6.4 0 011.323-3.902l.12-.156c3.731-4.864 11.508-2.228 11.508 3.902v12.662c0 8.833 7.161 15.994 15.994 15.994s15.994-7.161 15.994-15.994v-52.413h-88.421z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aB)",
    d: "M180.966 293.517h-80.595a126.758 126.758 0 006.872 12.188c.602.941.932 2.031.932 3.148v59.698h12.776v-30.723c0-5.074 6.046-7.744 9.766-4.293 14.182 13.154 31.771 24.763 52.67 34.741 4.929-1.104 8.615-5.498 8.615-10.76V304.55c-.002-6.092-4.942-11.033-11.036-11.033z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aC)",
    d: "M116.966 218.483H93.737c-7.16 24.453-5.124 50.674 6.111 73.992.169.35.35.694.522 1.043h16.595c6.094 0 11.034-4.94 11.034-11.034v-52.966c.001-6.095-4.939-11.035-11.033-11.035z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aD)",
    d: "M116.966 218.483H93.737c-7.16 24.453-5.124 50.674 6.111 73.992.169.35.35.694.522 1.043h16.595c6.094 0 11.034-4.94 11.034-11.034v-52.966c.001-6.095-4.939-11.035-11.033-11.035z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aE)",
    d: "M162.655 148.268c-28.209 8.962-50.611 28.436-63.081 54.835a105.196 105.196 0 00-5.837 15.38h87.228c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-5.184-3.579-9.52-8.398-10.704a111.202 111.202 0 00-20.946 4.489z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aF)",
    d: "M162.655 148.268c-28.209 8.962-50.611 28.436-63.081 54.835a105.196 105.196 0 00-5.837 15.38h87.228c6.094 0 11.034-4.94 11.034-11.034v-52.966c0-5.184-3.579-9.52-8.398-10.704a111.202 111.202 0 00-20.946 4.489z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aG)",
    d: "M320 154.483v52.966c0 6.094 4.94 11.034 11.034 11.034h91.359c.098-4.142.013-8.262-.293-12.355-1.769-23.692-11.473-45.628-27.303-62.68h-63.763c-6.094 0-11.034 4.941-11.034 11.035z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aH)",
    d: "M397.171 207.99c-1.775-23.765-14.078-45.214-33.755-58.848-18.224-12.628-40.403-16.917-62.451-12.079a86.33 86.33 0 00-3.88.945c-20.407 5.468-37.69 18.025-48.665 35.358a78.348 78.348 0 00-5.207 9.65 78.083 78.083 0 00-9.333-5.753c-18.172-9.523-39.417-11.757-59.823-6.289-1.278.342-2.567.72-3.832 1.122-21.513 6.834-38.575 21.638-48.044 41.685-10.224 21.646-10.155 46.374.19 67.843 7.623 15.82 19.684 30.052 36.035 42.579 9.183 7.036 14.488 18.013 14.488 29.581v19.158c0 8.833 7.161 15.994 15.994 15.994s15.994-7.161 15.994-15.994v-10.393c0-5.678 5.678-9.605 10.99-7.6l.164.062a8.146 8.146 0 015.27 7.621v54.584a6.388 6.388 0 1012.776 0v-48.003c0-3.965 3.806-6.809 7.616-5.711 15.073 4.346 28.08 7.045 36.539 8.567 5.075.913 10.42.683 15.456-.666s9.78-3.822 13.719-7.151c11.905-10.06 34.819-30.933 54.541-57.693 25.654-34.814 37.504-67.977 35.218-98.569z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aI)",
    d: "M308.966 218.483H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aJ)",
    d: "M308.966 218.483H203.034c-6.094 0-11.034-4.94-11.034-11.034v-52.966c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.966c.001 6.093-4.939 11.034-11.033 11.034z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aK)",
    d: "M383.954 133.323a105.463 105.463 0 00-6.299-4.731c-23.999-16.628-53.137-22.292-82.044-15.95-1.66.364-3.341.773-4.997 1.217-12.592 3.374-24.277 8.848-34.615 16.094v2.461c0 6.094 4.94 11.034 11.034 11.034h105.931c5.789 0 10.526-4.457 10.99-10.125z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aL)",
    d: "M383.954 133.323a105.463 105.463 0 00-6.299-4.731c-20.71-14.35-45.248-20.526-70.161-17.875v32.732h65.471c5.788-.001 10.525-4.458 10.989-10.126z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aM)",
    d: "M240.265 143.448h4.701c6.094 0 11.034-4.94 11.034-11.034v-2.461a106.407 106.407 0 00-15.735 13.495z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aN)",
    d: "M192 168.165a85.63 85.63 0 00-21.775 3.93c-21.513 6.834-38.575 21.638-48.044 41.685a80.193 80.193 0 00-2.034 4.704h60.82c6.094 0 11.034-4.94 11.034-11.034v-39.285z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aO)",
    d: "M192 168.165a85.63 85.63 0 00-21.775 3.93c-21.513 6.834-38.575 21.638-48.044 41.685a80.193 80.193 0 00-2.034 4.704h60.82c6.094 0 11.034-4.94 11.034-11.034v-39.285z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aP)",
    d: "M397.395 218.483a101.14 101.14 0 00-.223-10.493c-1.775-23.765-14.078-45.214-33.755-58.848a79.539 79.539 0 00-9.625-5.693h-22.757c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aQ)",
    d: "M244.966 293.517H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aR)",
    d: "M244.966 293.517H139.034c-6.094 0-11.034-4.94-11.034-11.034v-52.965c0-6.094 4.94-11.034 11.034-11.034h105.931c6.094 0 11.034 4.94 11.034 11.034v52.965c.001 6.094-4.939 11.034-11.033 11.034z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aS)",
    d: "M384 270.215v-40.697c0-6.094-4.94-11.034-11.034-11.034H267.034c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h103.931c5.074-7.865 9.414-15.635 13.035-23.303z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aT)",
    d: "M384 270.215v-40.697c0-6.094-4.94-11.034-11.034-11.034H267.034c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h103.931c5.074-7.865 9.414-15.635 13.035-23.303z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aU)",
    d: "M308.966 293.517H203.034c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h1.847v-6.004c0-5.678 5.677-9.604 10.99-7.6l.164.062a8.146 8.146 0 015.27 7.621v5.921h12.815c.394-3.613 3.982-6.088 7.576-5.051a374.944 374.944 0 0019.487 5.051h39.809a35.216 35.216 0 006.418-4.301 358.521 358.521 0 0012.589-11.176v-48.523c.001-6.093-4.939-11.034-11.033-11.034z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aV)",
    d: "M308.966 293.517H203.034c-6.094 0-11.034 4.94-11.034 11.034v52.966c0 6.094 4.94 11.034 11.034 11.034h1.847v-6.004c0-5.678 5.677-9.604 10.99-7.6l.164.062a8.146 8.146 0 015.27 7.621v5.921h12.815c.394-3.613 3.982-6.088 7.576-5.051a374.944 374.944 0 0019.487 5.051h39.809a35.216 35.216 0 006.418-4.301 358.521 358.521 0 0012.589-11.176v-48.523c.001-6.093-4.939-11.034-11.033-11.034z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aW)",
    d: "M192 304.552c0-6.094-4.94-11.034-11.034-11.034h-51.824c7.35 11.136 17.122 21.381 29.264 30.684 9.183 7.036 14.488 18.013 14.488 29.581v14.769h8.072c6.094 0 11.034-4.94 11.034-11.034z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aX)",
    d: "M192 304.552c0-6.094-4.94-11.034-11.034-11.034h-51.824c7.35 11.136 17.122 21.381 29.264 30.684 9.183 7.036 14.488 18.013 14.488 29.581v14.769h8.072c6.094 0 11.034-4.94 11.034-11.034z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aY)",
    d: "M481.195 133.522c0-19.578-16.948-35.197-36.973-32.986-15.221 1.681-27.525 13.985-29.206 29.205-2.212 20.026 13.407 36.975 32.985 36.975h.053c2.802-.006 5.12 2.155 5.12 4.957v70.215a9.175 9.175 0 0018.35 0v-68.141c0-8.941 2.388-17.636 6.316-25.667a33.066 33.066 0 003.355-14.558z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__aZ)",
    d: "M444.221 100.536c-15.221 1.681-27.525 13.985-29.207 29.205a33.44 33.44 0 001.311 13.707h63.347a33.148 33.148 0 001.522-9.926c.001-19.578-16.948-35.197-36.973-32.986z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__ba)",
    d: "M436.966 143.448h-20.64c4.221 13.482 16.801 23.268 31.675 23.268v-12.233c-.001-6.094-4.941-11.035-11.035-11.035z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__bb)",
    d: "M459.034 143.448c-6.094 0-11.034 4.94-11.034 11.034v12.234h.053c2.802-.006 5.119 2.155 5.119 4.957v45.111a10.966 10.966 0 005.862 1.698h12.488v-44.736c0-8.94 2.388-17.636 6.316-25.667a32.864 32.864 0 001.834-4.632h-20.638z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__bc)",
    d: "M216.058 288.807c-9.221 2.471-18.7-3.002-21.171-12.223l-2.294-8.562c-2.471-9.221 3.001-18.7 12.223-21.171 9.221-2.471 18.7 3.001 21.171 12.223l2.294 8.562c2.471 9.221-3.001 18.7-12.223 21.171z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__bd)",
    d: "M317.919 261.513c-9.221 2.471-18.7-3.001-21.171-12.223l-2.294-8.562c-2.471-9.221 3.001-18.7 12.223-21.171 9.221-2.471 18.7 3.002 21.171 12.223l2.294 8.562c2.471 9.222-3.001 18.7-12.223 21.171z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clip-art_svg__be)",
    d: "M325.648 283.084c-2.025.543-3.614 2.075-4.302 4.055-6.273 18.053-21.085 32.783-40.937 38.102s-40.045-.03-54.504-12.529c-1.586-1.371-3.729-1.903-5.754-1.361-4.82 1.292-6.259 7.456-2.489 10.725 17.486 15.158 41.938 21.651 65.974 15.21s41.965-24.29 49.53-46.16c1.631-4.714-2.698-9.333-7.518-8.042z"
  })));
}
export default __webpack_public_path__ + "static/clip-art.c98a5680.svg";
export { SvgClipArt as ReactComponent };